import toast from 'react-hot-toast';

/**
 * Función que muestra un toast de error si la condición no se cumple.
 * @param {boolean} condition - La condición que debe cumplirse.
 * @param {string} message - El mensaje de error si la condición no se cumple.
 */
export function invariantWithToast(condition, message) {
  if (condition === true) {
    toast.error(message);
    throw new Error(message);
  }
}